import { ref, computed } from 'vue'
import fileService from '&/services/fileService'

// Usar refs individuales en lugar de reactive
const title = ref(null)
const subtitle = ref(null)
const subSubtitle = ref(null)
const pattern = ref(null)
const country = ref(null)
const gameColor = ref('#6440A4')

export function useHeader() {
  // Setters
  function setHeaderTitle(val) { title.value = val }
  function setHeaderSubtitle(val) { subtitle.value = val }
  function setHeaderSubSubtitle(val) { subSubtitle.value = val }
  function setHeaderPattern(patternVal, countryVal = null) {
    pattern.value = fileService.getRelativeFileUrl(patternVal)
    country.value = countryVal
  }
  function setGameColor(color) {
    gameColor.value = color
  }
  function clearHeader() {
    title.value = null
    subtitle.value = null
    subSubtitle.value = null
    pattern.value = null
    country.value = null
  }

  return {
    title,
    subtitle,
    subSubtitle,
    pattern,
    country,
    gameColor,
    setHeaderTitle,
    setHeaderSubtitle,
    setHeaderSubSubtitle,
    setHeaderPattern,
    setGameColor,
    clearHeader,
  }
}
